import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Surface non-blocking upload warnings (e.g. a checkerboard baked into an image).
api.interceptors.response.use((res) => {
  if (res.config?.url?.includes("/admin/upload") && res.data?.warning) {
    toast.warning(res.data.warning, { duration: 8000 });
  }
  return res;
});

// Resolve an image URL: backend file paths get the backend origin prefix.
export function resolveImg(url) {
  if (!url) return undefined;
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}

export default api;
